// eslint-disable-next-line
import {
  GetMe,
  UpdateMe,
  uploadUserPhotoV2,
} from '@/api/api';

const defaultProfile = require('@/assets/img/gw/user/default_profile.jpg');

export default {
  namespaced: true,
  state: {
    /* = data */
    user: {
      photo_url: null,
    },
    userName: null,
    loading: false,
  },

  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */
  },

  actions: {
    /* = Methods */
    apiGetUser({
      commit,
    }) {
      commit('setDefaultImage');
      GetMe().then((response) => commit('setUserInfo', response)).catch();
    },
    async apiUpdateUser({ commit, state }, userNewPhoto) {
      commit('cahngeLoadStatus', true);
      const {
        name,
        // eslint-disable-next-line
        last_name,
        username,
        email,
        phone,
      } = state.user;
      await UpdateMe({ name, last_name, username, email, phone})
            .then(async (user) => {
              if (userNewPhoto && userNewPhoto.url) {
                await uploadUserPhotoV2(user.user_id, userNewPhoto).then(userWithPhoto => {
                  if (userWithPhoto) {
                    user = userWithPhoto;
                  }
                });
              }

              commit('setUserInfo', user)
            }).finally(() => {
              commit('cahngeLoadStatus', false);
            });
    },

  },

  mutations: {
    /* Mutations are responsible to change the state */
    cahngeLoadStatus(state, status) {
      state.loading = status;
    },
    async setDefaultImage(state) {
      state.user.photo_url = defaultProfile;
    },
    setUserInfo(state, data) {
      state.user = data;
    },

  },
};
